import React from 'react';
import { Profile } from '../Profile';
import { PageWrapper } from '../PageWrapper';
import { TAB_NAMES } from '../../constants';
import { AlertsSettings } from '../../../AlertsSettings';
import { Scanning } from '../../../Scanning';
import { GoProCloudSettings } from '../../../GoProCloudSettings';

export const PageContent = ({ activeTab }) => {
  switch (activeTab) {
    case TAB_NAMES.profile:
      return (
        <PageWrapper header='Your information'>
          <Profile />
        </PageWrapper>
      );
    case TAB_NAMES.alerts:
      return (
        <PageWrapper header='Alerts Settings'>
          <AlertsSettings />
        </PageWrapper>
      );
    case TAB_NAMES.transactions:
      return (
        <PageWrapper header='Scanning'>
          <Scanning />
        </PageWrapper>
      );
    case TAB_NAMES.gopro:
      return (
        <PageWrapper header='GoPRO Cloud Settings'>
          <GoProCloudSettings />
        </PageWrapper>
      );
    default:
      return null;
  }
};
